import React from 'react';
import { Grid } from '@mui/material';
import DataGridItem from '../dataGrid/DataGridItem';

const capexFields = [
  'total_gross_project_cost',
  'payback_period',
  'IRR',
  'total_1st_year_net_revenue',
  'total_30_year_net_revenue',
  'net_present_value'
];

const customerPPAFields = [
  'customer_ppa_cost',
  'customer_payback_period',
  '1_year_savings',
  '25_year_savings',
  // 'total_1st_year_net_revenue',
  // 'total_30_year_net_revenue',
  'ppa_rate_kwh'
  // 'ppa_rate_kw'
];

const vendorPPAFields = [
  'capex_y0',
  'IRR',
  '1_year_net_revenue',
  '25_year_net_revenue',
  'payback_period',
  'net_present_value'
];

const adminPPAFields = [...customerPPAFields, ...vendorPPAFields];

const updateLabelsForAdmin = (data, isAdmin = false) => {
  return isAdmin
    ? data.map(item => {
        if (customerPPAFields.includes(item.id)) {
          return {
            ...item,
            label: `Customer ${item.label}`
          };
        }

        if (vendorPPAFields.includes(item.id)) {
          return {
            ...item,
            label: `PPA Owner ${item.label}`
          };
        }

        return item;
      })
    : data;
};

const FinancialsSummary = ({
  buildingId,
  data,
  loading,
  financialMode,
  isAdmin = false,
  isVendor = false
}) => {
  let includedFields = capexFields;

  if (buildingId && financialMode === 'ppa') {
    if (isVendor) {
      includedFields = vendorPPAFields;
    }

    if (isAdmin) {
      includedFields = adminPPAFields;
    }

    if (!isAdmin && !isVendor) {
      includedFields = customerPPAFields;
    }
  }

  const fields = updateLabelsForAdmin(
    data.filter(item => includedFields.includes(item.id)),
    isAdmin && financialMode === 'ppa'
  );

  return (
    <Grid container>
      <Grid item xs={12} lg={12}>
        <Grid container spacing={2}>
          {fields.map(d => (
            <DataGridItem
              isLoading={loading}
              key={d.label}
              lg={6}
              md={6}
              sm={6}
              digits={d.id === 'ppa_rate_kwh' ? 4 : undefined}
              {...d}
            />
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FinancialsSummary;
